/* HIP&TELL free-gift auto-add. Dipindah dari snippets/ht-gift-auto.liquid (2026-09-13); aturan hadiah tetap dihitung Liquid dan dititip di window.htGiftRules. Logika identik. */
(function () {
  if (window.htGiftAutoBound) return;
  window.htGiftAutoBound = true;

  var RULES = window.htGiftRules || [];
  if (!RULES.length) return;

  var GIFT_IDS = RULES.map(function (r) { return r.variant; });
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var busy = false;
  var timer = null;
  /* Cart handed to us by the last cart:change, so the debounced pass can
     start from it instead of asking the server what it already told us. */
  var pendingSeed = null;
  /* A gift that Shopify refused to discount, or that we could not add at
     all, is parked here for the rest of the page life. Without this the
     add -> not-free -> remove -> cart:refresh -> add cycle never ends:
     every pass would look like fresh work and re-dispatch itself. */
  var blocked = {};

  /* `blocked` dies with the page — and on /cart the page is exactly what
     this script reloads. That is how a refused gift turned into an endless
     loop (Malaysia, measured 2026-10-13: RM 178 bag, the RM 149 setting
     asked for the bag, Shopify priced it RM 93, out it went, reload, again,
     about once a second). So a refusal is also written to sessionStorage,
     keyed by the bag it was refused for: the same bag is not asked again,
     a bag that grew is. Storage can be missing or throw (private mode);
     then this is a no-op and the guards below still hold. */
  var STORE_BLOCK = 'htGiftBlocked';
  var STORE_RELOADS = 'htGiftReloads';

  function readStore(key, fallback) {
    try {
      var raw = window.sessionStorage.getItem(key);
      return raw ? JSON.parse(raw) : fallback;
    } catch (e) { return fallback; }
  }

  function writeStore(key, value) {
    try { window.sessionStorage.setItem(key, JSON.stringify(value)); } catch (e) { /* no storage */ }
  }

  /* A refusal is only remembered for the bag it happened on: same
     currency, same goods total, same live codes. Drop or add a code, change
     the bag, or wait half an hour, and the gift is asked for again (Codex
     review 2026-10-13: a code-health refusal must not outlive the code). */
  var BLOCK_TTL = 30 * 60 * 1000;

  function bagKey(cart) {
    return (cart.currency || '') + ':' + qualifyingTotal(cart) + ':' + activeCodes(cart).join(',');
  }

  function block(variant, cart) {
    blocked[variant] = bagKey(cart);
    var saved = readStore(STORE_BLOCK, {});
    saved[variant] = { k: bagKey(cart), t: Date.now() };
    writeStore(STORE_BLOCK, saved);
  }

  /* A request that simply failed (network, sold out) is not a refusal —
     park it for this page only, as before. */
  function blockForPage(variant, cart) {
    blocked[variant] = bagKey(cart);
  }

  function isBlocked(variant, cart) {
    var key = bagKey(cart);
    if (blocked[variant] === key) return true;
    var saved = readStore(STORE_BLOCK, {})[variant];
    return !!saved && saved.k === key && Date.now() - saved.t < BLOCK_TTL;
  }

  /* Last line of defence on /cart: whatever goes wrong, this script may
     reload the page at most twice in 30 seconds. A third would mean the
     cart is not settling — redraw instead and say so in the console. */
  function recentReloads() {
    var now = Date.now();
    return readStore(STORE_RELOADS, []).filter(function (t) { return now - t < 30000; });
  }

  function reloadAllowed() {
    var recent = recentReloads();
    if (recent.length >= 2) return false;
    recent.push(Date.now());
    writeStore(STORE_RELOADS, recent);
    return true;
  }

  /* What /cart was rendered from — the first reading of the cart on this
     page. When the cap swallows a reload, check back once the window has
     passed and reload then if the cart still differs from what is on
     screen, so a real change is never left invisible (Codex review
     2026-10-13). A genuine loop is slowed to one turn per window. */
  var pageSig = null;
  var catchUp = null;

  function scheduleCatchUp() {
    if (catchUp) return;
    var recent = recentReloads();
    var wait = recent.length ? Math.max(1000, 30000 - (Date.now() - recent[0]) + 500) : 1000;
    catchUp = setTimeout(function () {
      catchUp = null;
      getCart().then(function (cart) {
        if (pageSig !== null && signature(cart) === pageSig) return;
        if (reloadAllowed()) window.location.reload();
        else scheduleCatchUp();
      }, function () { /* leave the page as it is */ });
    }, wait);
  }

  /* What the shopper would see change: every line, its price, and the codes
     that are live. Used to tell a pass that moved the cart from one that
     added a gift and took it straight back out. */
  function hasPaidGift(cart) {
    return !!cart && !!cart.items && cart.items.some(function (item) {
      return GIFT_IDS.indexOf(item.variant_id) !== -1 && item.final_line_price !== 0;
    });
  }

  function signature(cart) {
    if (!cart || !cart.items) return '';
    return cart.items.map(function (item) {
      return item.variant_id + 'x' + item.quantity + '@' + item.final_line_price;
    }).join(',') + '|' + activeCodes(cart).join(',');
  }

  function getCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function change(variantId, qty) {
    return fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: String(variantId), quantity: qty })
    }).then(function (r) { return r.json(); });
  }

  function add(variantId) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    }).then(function (r) {
      /* Out of stock, or the gift went unavailable — leave the cart alone.
         A shopper must never see an error because a freebie ran out. */
      if (!r.ok) throw new Error('add-failed');
      return r.json();
    });
  }

  /* Every gift the bag just earned, in one request. Shopify returns
     { items: [...] }, each carrying the price it settled at, so the guard
     still gets to check all of them. */
  function addMany(variantIds) {
    if (variantIds.length === 1) {
      return add(variantIds[0]).then(function (item) { return { items: [item] }; });
    }
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: variantIds.map(function (id) { return { id: Number(id), quantity: 1 }; })
      })
    }).then(function (r) {
      if (!r.ok) throw new Error('add-failed');
      return r.json();
    });
  }

  function lineFor(cart, variantId) {
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].variant_id === variantId) return cart.items[i];
    }
    return null;
  }

  /* The codes the cart is honoring right now. Snapshotted before any gift
     is added, and compared after: a code this list loses the moment a gift
     lands is a code that gift just killed — see the health check in
     sync(). */
  function activeCodes(cart) {
    return (cart.discount_codes || [])
      .filter(function (c) { return c.applicable; })
      .map(function (c) { return c.code; });
  }

  /* What the shopper put in the bag: non-gift line prices after
     product-level discounts, BEFORE any order-level code. That is the
     same basis Shopify judges the gift's own Rp 999.000 prerequisite on —
     product discounts settle first, and only then does an order code take
     its cut of the subtotal (help.shopify.com discount-combinations,
     re-checked 2026-08-31). So a Rp 1.084.600 bag wearing HIP10 earns the
     belt on the full 1.084.600, and the code then discounts the rest.
     Gifts are excluded so a gift already in the cart can never help clear
     the bar that put it there. */
  function qualifyingTotal(cart) {
    return cart.items.reduce(function (sum, item) {
      if (GIFT_IDS.indexOf(item.variant_id) !== -1) return sum;
      return sum + item.final_line_price;
    }, 0);
  }

  function hasProduct(cart, productId) {
    return cart.items.some(function (item) { return item.product_id === productId; });
  }

  /* The gift's own discount is set in Rupiah. In MYR/SGD Shopify converts
     that minimum at the store's live rate, so the market setting must never
     sit below it — if it does, take the converted floor instead. */
  function thresholdFor(rule) {
    var t = rule.threshold;
    var cur = window.Shopify && window.Shopify.currency;
    if (rule.idrThreshold && cur && cur.active && cur.active !== 'IDR') {
      var rate = parseFloat(cur.rate);
      if (rate > 0) t = Math.max(t, Math.ceil(rule.idrThreshold * rate));
    }
    return t;
  }

  function earned(cart, rule) {
    if (rule.requires && !hasProduct(cart, rule.requires)) return false;
    return qualifyingTotal(cart) >= thresholdFor(rule);
  }

  function sync(seed) {
    if (busy) return Promise.resolve(false);
    busy = true;
    var wrote = false;
    var startSig = null;
    var firstOfPage = pageSig === null;

    /* cart:change carries the whole cart in its detail. On the path that
       actually matters — the shopper just added something and is watching
       the drawer — that lets us skip a read and go straight to the write.
       A seed missing discount_codes is not trusted: the code health check
       needs the before-picture of the shopper's codes, and a seed without
       them would let a code die invisibly. */
    var read = seed && seed.items && seed.discount_codes ? Promise.resolve(seed) : getCart();

    return read
      .then(function (cart) {
        if (!cart || !cart.items || !cart.items.length) return null;
        startSig = signature(cart);
        if (firstOfPage && pageSig === null) pageSig = startSig;

        /* Decide everything from one reading of the cart, then act once.
           Serving gifts one per pass cost a round trip each — a bag earning
           both a belt and a scarf took about two seconds to settle. */
        var wanted = [];
        var chores = [];

        var sweeping = false;
        for (var i = 0; i < RULES.length; i++) {
          var rule = RULES[i];
          var line = lineFor(cart, rule.variant);
          var deserved = earned(cart, rule) && !isBlocked(rule.variant, cart);

          if (deserved && !line) {
            wanted.push(rule.variant);
          } else if (!deserved && line) {
            /* A blocked gift still gets cleaned out if it is sitting there. */
            chores.push([rule.variant, 0]);
            sweeping = true;
          } else if (deserved && line && line.quantity > 1) {
            /* A gift is one, never two. */
            chores.push([rule.variant, 1]);
          }
        }

        /* The add-time zero check never sees a gift that was ALREADY in
           the bag. If Shopify stopped zeroing it — discount paused, its
           window closed, or the engine spent the order's one free slot on
           another gift line — it would ride to checkout at full price.
           So an earned gift sitting there at a non-zero price goes out
           too, and is not asked for again on this page. Skipped while a
           sweep is pending: the free slot may be the very thing the
           sweep is about to free up, and the next pass re-reads the cart
           (Codex review 2026-09-11). */
        if (!sweeping) {
          for (var k = 0; k < RULES.length; k++) {
            var gift = lineFor(cart, RULES[k].variant);
            if (gift && gift.quantity === 1 && gift.final_line_price !== 0 &&
                earned(cart, RULES[k]) && !isBlocked(RULES[k].variant, cart)) {
              block(RULES[k].variant, cart);
              chores.push([RULES[k].variant, 0]);
            }
          }
        }

        if (!wanted.length && !chores.length) return null;
        wrote = true;

        /* Removals go one at a time — cart/change.js takes a single line,
           and there is rarely more than one. Additions go together. */
        var work = chores.reduce(function (chain, job) {
          return chain.then(function () { return change(job[0], job[1]); });
        }, Promise.resolve());

        if (!wanted.length) return work;

        var codesBefore = activeCodes(cart);

        return work
          .then(function () { return addMany(wanted); })
          .then(function (res) {
            /* THE GUARD, and it costs nothing: cart/add.js reports what each
               line comes to once Shopify has applied its discounts, so there
               is no second cart read. Anything that did not come back free
               goes straight back out — before the shopper is ever asked to
               pay for it — and is not asked for again on this page. */
            var strays = (res && res.items ? res.items : []).filter(function (item) {
              return item.final_line_price !== 0;
            });
            return strays.reduce(function (chain, item) {
              block(item.variant_id, cart);
              return chain.then(function () { return change(item.variant_id, 0); });
            }, Promise.resolve());
          })
          .catch(function () {
            /* Shopify rejects the whole batch if any single line fails, so
               a sold-out belt must not cost the shopper their scarf. Retry
               them individually and only blame the one that actually broke. */
            return wanted.reduce(function (chain, variant) {
              return chain.then(function () {
                return add(variant)
                  .then(function (added) {
                    if (added && added.final_line_price !== 0) {
                      block(variant, cart);
                      return change(variant, 0);
                    }
                  })
                  .catch(function () { blockForPage(variant, cart); });
              });
            }, Promise.resolve());
          })
          .then(function () {
            /* CODE HEALTH CHECK. The zero-check above cannot see the other
               way a gift goes wrong: a code that refuses to combine with
               the gift's discount gets deactivated by Shopify the moment
               the gift lands — the gift itself still reads Rp 0, the
               victim is the code (measured 2026-08-31, before HIP10 was
               made combinable). The store's codes combine with the gift
               now, so normally this costs one cart read and finds nothing.
               But codes minted by automations (birthday rewards) may still
               carry the old no-combine setting: for those, pull the gifts
               straight back out, park them for this page life, and re-run
               the /discount/ link to bring the shopper's code back. */
            if (!codesBefore.length) return;
            return getCart().then(function (now) {
              var alive = activeCodes(now);
              var dead = codesBefore.filter(function (code) { return alive.indexOf(code) === -1; });
              if (!dead.length) return;
              return wanted
                .reduce(function (chain, variant) {
                  block(variant, cart);
                  return chain.then(function () { return change(variant, 0); });
                }, Promise.resolve())
                .then(function () {
                  return dead.reduce(function (chain, code) {
                    return chain.then(function () {
                      return fetch(root + 'discount/' + encodeURIComponent(code));
                    });
                  }, Promise.resolve());
                });
            });
          });
      })
      .catch(function () { /* never let a freebie break the cart */ })
      .then(function () {
        /* "Touched" means the cart the shopper sees is different now — not
           that we wrote to it. Adding a gift and pulling it straight back
           out is a write with nothing to show, and treating it as a change
           is what made /cart reload itself forever. One extra cart read,
           only on passes that wrote. */
        if (!wrote) return false;
        return getCart().then(
          function (after) {
            if (pageSig === null) pageSig = startSig;
            /* A gift still sitting there at a price means a removal did not
               go through (Codex review 2026-10-13) — report it as moved so
               runPasses tries again; its depth cap and reloadAllowed() keep
               that bounded. */
            return signature(after) !== startSig || hasPaidGift(after);
          },
          function () { return true; }
        );
      })
      .then(
        function (moved) { busy = false; return moved; },
        function () { busy = false; return false; }
      );
  }

  /* A pass decides everything from ONE reading of the cart, acts, and
     stops — every write invalidates the copy it was reasoning about. It
     used to get its next turn from the redraw event it fired; now that we
     ignore our own event, the passes chain here instead: keep going while
     something moved, re-reading each time, redrawing after each pass that
     touched the cart. Capped because a cart that never settles is a bug,
     not a reason to hammer Shopify. */
  function runPasses(seed, redraw) {
    function step(s, depth) {
      if (depth > 4) return;
      return sync(s).then(function (touched) {
        if (!touched) return;
        /* Paint the moment the gift lands, then keep checking quietly. The
           settling pass costs a cart read, and making the shopper wait
           through it added about four tenths of a second to a drawer that
           already had everything it needed to show. */
        redraw();
        return step(null, depth + 1);
      });
    }
    return Promise.resolve(step(seed, 0));
  }

  function schedule(evt) {
    /* Our own redraw comes back round as an event. Ignore it: the pass it
       would trigger has nothing left to do and only costs a cart read. */
    if (evt && evt.detail && evt.detail.htGiftSelf) return;
    if (evt && evt.detail && evt.detail.cart && evt.detail.cart.items) {
      pendingSeed = evt.detail.cart;
    }
    clearTimeout(timer);
    timer = setTimeout(function () {
      var seed = pendingSeed;
      pendingSeed = null;
      /* Only redraws when something actually moved, so we cannot loop: a
         pass that changes nothing calls nothing. */
      runPasses(seed, function () {
        /* The drawer rebuilds itself from cart:refresh, but the /cart page
           is server-rendered once and never hears it — the gift landed in
           the cart while the page still read "Bag (6)" with no belt in
           sight. Reload there instead. This comment used to promise "never
           a loop" on the strength of `touched` alone — it looped in Malaysia
           for a month (2026-10-13). Now three things stand in the way: a
           pass only counts as moved if the cart reads differently after it,
           a refused gift stays refused across the reload (sessionStorage),
           and reloadAllowed() caps it at two in 30 seconds regardless. */
        if (document.body.classList.contains('template-cart') ||
            /^\/(?:[a-z-]+\/)?cart\/?$/.test(window.location.pathname)) {
          if (reloadAllowed()) {
            window.location.reload();
            return;
          }
          console.warn('[ht-gift-auto] cart not settling — reload deferred');
          scheduleCatchUp();
        }
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { htGiftSelf: true } }));
      });
    }, 60);
  }

  ['cart:change', 'cart:refresh', 'cart:updated'].forEach(function (evt) {
    document.addEventListener(evt, schedule);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
})();
